// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eVC0","toggle":"styles_toggle__2EdH_","preview":"styles_preview__2ECeE"};